"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Autocomplete = void 0;
const react_1 = __importStar(require("react"));
const clsx_1 = __importDefault(require("clsx"));
const react_dom_1 = require("react-dom");
const use_debounce_1 = require("use-debounce");
const ArrowDropDown_1 = __importDefault(require("@material-ui/icons/ArrowDropDown"));
const IconButton_1 = __importDefault(require("@material-ui/core/IconButton"));
const Clear_1 = __importDefault(require("@material-ui/icons/Clear"));
const Popper_1 = __importDefault(require("@material-ui/core/Popper"));
const Paper_1 = __importDefault(require("@material-ui/core/Paper"));
const Chip_1 = __importDefault(require("@material-ui/core/Chip"));
const ClickAwayListener_1 = __importDefault(require("@material-ui/core/ClickAwayListener"));
const event_callback_hook_1 = require("../../utils/event-callback-hook");
const text_field_1 = require("../text-field/text-field");
const infinite_list_1 = require("../infinite-list/infinite-list");
const autocomplate_styles_1 = require("./autocomplate-styles");
const autocomplete_item_1 = require("./autocomplete-item");
function Autocomplete({ disabled, value, onChange, source, clearable = true, multiple = false, labelMapper = (option) => option.name, // fixme: memorize
tooltipMapper, ItemComponent = autocomplete_item_1.AutocompleteItem, showTooltip, DisabledComponent = text_field_1.TextField, closeOnSelect = false, }) {
    var _a;
    // fix undefined value
    value = value !== null && value !== void 0 ? value : null;
    const singleValue = value;
    const multipleValue = (_a = value) !== null && _a !== void 0 ? _a : [];
    const multipleIds = multiple ? multipleValue.map((item) => item.id) : [];
    const singleLabel = singleValue != null ? labelMapper(singleValue, 'FIELD') : '';
    const multiLabel = multiple
        ? multipleValue.map((val) => labelMapper(val, 'FIELD')).join(', ')
        : '';
    const { paper, paperItem, popper, icon, iconOpened, wrapper, wrapperDisabled, chips, chip, input, clearButton, } = autocomplate_styles_1.useStyles();
    const [popupOpen, setPopupOpen] = react_1.useState(false);
    const anchorEl = react_1.useRef(null);
    const [textValue, setTextValue] = react_1.useState(null);
    const infiniteList = react_1.useRef(null);
    const handleItemClick = event_callback_hook_1.useEventCallback(async (option) => {
        if (multiple) {
            // toggle item
            if (multipleIds.includes(option.id)) {
                onChange(multipleValue.filter((v) => v.id !== option.id));
            }
            else {
                option = await source.loadDetail(option);
                onChange([...multipleValue, option]);
            }
            if (closeOnSelect) {
                setPopupOpen(false);
                setTextValue("");
            }
        }
        else {
            // select item and close popup
            option = await source.loadDetail(option);
            onChange(option);
            setPopupOpen(false);
            const value = labelMapper(option, 'FIELD');
            setTextValue(value);
            setSearchQuery(value);
        }
    });
    const error = !multiple &&
        textValue !== (value !== null ? labelMapper(singleValue, 'FIELD') : null);
    const handleClickAway = event_callback_hook_1.useEventCallback((e) => {
        setPopupOpen(false);
        if (error) {
            handleClear(e);
        }
    });
    const [setSearchQuery] = use_debounce_1.useDebouncedCallback((value) => {
        react_dom_1.unstable_batchedUpdates(() => {
            var _a;
            source.reset();
            source.setSearchQuery(value !== null && value !== void 0 ? value : '');
            (_a = infiniteList.current) === null || _a === void 0 ? void 0 : _a.reset();
        });
    }, 500);
    const handleChange = event_callback_hook_1.useEventCallback((value) => {
        setTextValue(value);
        setSearchQuery(value);
    });
    const handleClear = event_callback_hook_1.useEventCallback((e) => {
        e.stopPropagation();
        onChange(null);
        setTextValue(null);
        setSearchQuery(null);
    });
    const handleDelete = event_callback_hook_1.useEventCallback((value) => {
        onChange(multipleValue.filter((v) => v !== value));
    });
    const handleClick = event_callback_hook_1.useEventCallback(() => {
        if (!disabled) {
            react_dom_1.unstable_batchedUpdates(() => {
                var _a;
                source.reset();
                source.setSearchQuery(textValue !== null && textValue !== void 0 ? textValue : '');
                (_a = infiniteList.current) === null || _a === void 0 ? void 0 : _a.reset();
            });
            setPopupOpen(true);
        }
    });
    const handleKeyDown = event_callback_hook_1.useEventCallback((e) => {
        var _a, _b, _c;
        if (e.key !== 'Tab' && !popupOpen) {
            setPopupOpen(true);
        }
        if (e.key === 'ArrowUp') {
            e.preventDefault();
            (_a = infiniteList.current) === null || _a === void 0 ? void 0 : _a.focusPrevious();
        }
        else if (e.key === 'ArrowDown') {
            e.preventDefault();
            (_b = infiniteList.current) === null || _b === void 0 ? void 0 : _b.focusNext();
        }
        else if (e.key === 'Enter') {
            e.preventDefault();
            const item = (_c = infiniteList.current) === null || _c === void 0 ? void 0 : _c.getFocusedItem();
            if (item !== undefined) {
                handleItemClick(item);
            }
        }
        else if (e.key === 'Escape') {
            setPopupOpen(false);
            setTextValue('');
            setSearchQuery('');
        }
    });
    react_1.useEffect(() => {
        if (!multiple) {
            setTextValue(singleValue !== null ? labelMapper(singleValue, 'FIELD') : null);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [singleValue, multiple]);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { className: clsx_1.default('EasInput-root', wrapper, {
                [wrapperDisabled]: disabled,
            }) }, disabled ? (react_1.default.createElement(DisabledComponent, { disabled: true, value: multiple ? multiLabel : singleLabel })) : (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("div", { className: input, onClick: handleClick },
                react_1.default.createElement(text_field_1.TextField, { ref: anchorEl, error: error, endAdornment: react_1.default.createElement(react_1.default.Fragment, null,
                        clearable && value !== null && (react_1.default.createElement(IconButton_1.default, { className: clearButton, size: "small", onClick: handleClear },
                            react_1.default.createElement(Clear_1.default, { fontSize: "small" }))),
                        react_1.default.createElement(ArrowDropDown_1.default, { classes: {
                                root: clsx_1.default(icon, { [iconOpened]: popupOpen }),
                            } })), value: textValue, onChange: handleChange, onKeyDown: handleKeyDown })),
            multiple && multipleValue.length > 0 && (react_1.default.createElement("div", { className: chips }, multipleValue.map((value) => (react_1.default.createElement(Chip_1.default, { key: value.id, label: labelMapper(value, 'FIELD'), className: chip, variant: "outlined", size: "small", onDelete: !disabled ? () => handleDelete(value) : undefined })))))))),
        popupOpen && anchorEl && (react_1.default.createElement(Popper_1.default, { className: popper, role: "presentation", anchorEl: anchorEl.current, placement: "bottom-start", open: true },
            react_1.default.createElement(ClickAwayListener_1.default, { onClickAway: handleClickAway },
                react_1.default.createElement(Paper_1.default, { className: paper, square: true, elevation: 8 },
                    react_1.default.createElement(infinite_list_1.InfiniteList, { ref: infiniteList, source: source, onItemClick: handleItemClick, showTooltip: showTooltip, tooltipMapper: tooltipMapper, selectedIds: multipleIds, labelMapper: (item, index) => (react_1.default.createElement("div", { style: {
                                backgroundColor: index % 2 === 0 ? '#ededed55' : 'inherit',
                            }, className: paperItem },
                            react_1.default.createElement(ItemComponent, { item: item }, labelMapper(item, 'OPTION')))) })))))));
}
exports.Autocomplete = Autocomplete;
//# sourceMappingURL=autocomplete.js.map